import { render, staticRenderFns } from "./StockInventoryView.vue?vue&type=template&id=37c9e6ef&"
import script from "./StockInventoryView.vue?vue&type=script&lang=js&"
export * from "./StockInventoryView.vue?vue&type=script&lang=js&"
import style0 from "./StockInventoryView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports